import { translateCode, translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { TaskCategory } from '../TaskCategory'
import { allowedSubcategories } from '../TaskConfig'
import { TaskType } from '../TaskType'
import { BaseTask } from './BaseTask'
import { BrushesBrand } from './BrushesBrand'
import { BrushesVehicle } from './BrushesVehicle'

export interface MaintenanceTask extends BaseTask {
    type: TaskType.Maintenance
    assignments: MaintenanceJobAssignment[]
}

export enum MaintenanceTaskType {
    General = 'GENERAL',
    Winter = 'WINTER',
    Summer = 'SUMMER',
    Brushes = 'BRUSHES',
}

export const translateMaintenanceTaskType = (t: TFunction) =>
    translateEnum(t)(MaintenanceTaskType, 'maintenance-task-type')
export const allMaintenanceTaskTypes = EnumValues.getValues<MaintenanceTaskType>(
    MaintenanceTaskType,
).filter(q => allowedSubcategories[TaskCategory.Maintenance].includes(q))

export interface MaintenanceJob {
    id: number
    label: string
    code?: string
    jobType: MaintenanceTaskType
}

export const translateMaintenanceJob =
    (t: TFunction) => (v: Pick<MaintenanceJob, 'code' | 'label'>) =>
        translateCode(t)('maintenance-job', v.code, v.label)

export interface MaintenanceJobAssignment {
    job: MaintenanceJob | undefined
    brushesVehicle: BrushesVehicle
    brushesBrand: BrushesBrand
    engineLastShiftHours: number
    brushesLastShiftHours: number
    totalHours: number
}
